export const content = {
  format: 'Format',
  buchungsnummer: 'Buchungsnummer',
  mussKopplung: 'Muss-Kopplung',
};
